<div>
  <span class="position-fixed close-button text-xl" (click)="closeMenu()"
    ><i class="material-icons">close</i></span
    >
    @if (!isPartnerPortal) {
      <app-article-groups-browser
        class="d-block py-2"
        [listClass]="''"
        (menuClickedEvent)="closeMenu()"
        ><h3 class="d-block w-100 ps-3" style="padding-left: 1.25rem">
        {{ "CATALOG" | translate }}
      </h3></app-article-groups-browser
      >
    }
    <ul class="list-group">

      @for (item of menuItems; track item; let i = $index) {
        <li
          class="list-group-item border-0 rounded-0"
          [ngStyle]="{'order': i * 5}"
          >
          <h3 (click)="gotoItem(item)" [ngClass]="{'hasLink': !item.sub_items}">{{ item.description | translate }}</h3>
          @if (item.sub_items && item.sub_items.length) {
            <ul class="list-group" >
              @for (item of item.sub_items; track item; let i = $index) {
                <li
                  class="list-group-item ps-0"
                  (click)="gotoItem(item)"
                  >
                  <span
            [ngClass]="{
              'has-subitems': item.sub_items && item.sub_items.length
            }"
                    >{{ item.description | translate }}</span
                    >
                    @if (item.sub_items && item.sub_items.length) {
                      <ul
                        class="list-group deepest"
                        >
                        @for (item of item.sub_items; track item) {
                          <li class="list-group-item">
                            @if (item.sub_items && item.sub_items.length) {
                              <ul
                                class="list-group deepest"
                                >
                                @for (sub_item of item.sub_items; track sub_item) {
                                  <li
                                    class="list-group-item"
                                    >
                                    <span (click)="gotoItem(sub_item)">{{
                                      sub_item.description | translate
                                    }}</span>
                                  </li>
                                }
                              </ul>
                            }
                            @if (!item.sub_items) {
                              <span (click)="gotoItem(item)">{{
                                item.description | translate
                              }}</span>
                            }
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
        @if (accountInformation?.can_access_rakoo) {
          <li class="list-group-item" style="order: 5" >
            <h3 class="d-block w-100">Accell Academy</h3>
            <ul class="list-group">
              <li
                class="list-group-item ps-0"
                (click)="getRakooLearningUrl()"
                >
                <span> {{"START_RAKOO_TRAINING"|translate}}</span>
              </li>
              <li
                class="list-group-item ps-0"
                (click)="gotoRakoo()"
                >
                <span> {{"RAKOO_STORE"|translate}}</span>
              </li>
              <li
                class="list-group-item ps-0"
                (click)="closeMenu()"
        [routerLink]="
            applicationService.getSelectCompanyGroupCode() +
            '/companyPage/accell-academy-uitleg'"
                >
                <span> {{"EXPLANATION_ACCELL_ACADEMY"|translate}}</span>
              </li>
            </ul>
          </li>
        }
      </ul>
    </div>
